import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import OrangeFaqAccordion from "../components/orange_faq_accordion";
import ProductSpecs from "../components/product_specs";

class PurchaseScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { isLoggedIn } = this.props;
    const shopFaqs = [
      {
        id: "shop-faq1",
        question:
          "What age group is the XLP Learning Advance Kit suitable for?",
        answer:
          "The XLP Learning Advance Kit is designed for kids aged 10 years and above, making it ideal for students who are beginning to explore robotics, automation, and STEM learning.",
      },
      {
        id: "shop-faq2",
        question: "What will kids learn from this kit?",
        answer:
          "Kids will learn the basics of robotics, automation, mechanical systems, and problem-solving through hands-on building and experimentation.",
      },
      {
        id: "shop-faq3",
        question: "Do kids need prior knowledge of robotics to use this kit?",
        answer:
          "No prior experience is required. The kit is designed for beginners, helping students understand concepts step-by-step through practical activities.",
      },
      {
        id: "shop-faq4",
        question: "Can this kit be used in schools or workshops?",
        answer:
          "Yes, the XLP Learning Advance Kit is perfect for schools, STEM labs, robotics clubs, and workshops, as well as for learning at home.",
      },
      {
        id: "shop-faq5",
        question: "Is adult supervision required while using the kit?",
        answer:
          "While the kit is designed to be student-friendly, guidance from parents, teachers, or mentors is recommended for better learning and safe usage. ",
      },
      {
        id: "shop-faq6",
        question: "Is the kit reusable for multiple projects?",
        answer:
          "Yes, the components are durable and reusable, allowing kids to build multiple models and experiment with different robotics and automation concepts. ",
      },
    ];

    return (
      <>
        <Header isLoggedIn={isLoggedIn} />

        <ProductSpecs />

        <OrangeFaqAccordion
          subtitle="FAQ"
          title={
            <>
              Your Questions, <br /> Answered
            </>
          }
          faqs={shopFaqs}
        />

        <Footer />
      </>
    );
  }
}

export default PurchaseScreen;
